module.exports = __webpack_public_path__ + "img/ice-skating.b620e7eb.svg";